// extracted by mini-css-extract-plugin
export default {"post-message-content":"Message_post-message-content__th7Cg","button-area":"Message_button-area__5yrR3","text-editor":"Message_text-editor__47sf9"};